// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"121":"gallery","122":"intro","231":"values","611":"roadmap","658":"comics"}[chunkId] + "." + {"121":"b422b892","122":"2cc4884d","231":"4196995e","611":"12b04d64","658":"55516747"}[chunkId] + ".js";
};